// project imports
import { processDateFieldInput, processDateFieldOutput } from 'utils/processors';
import {
    processEntityInput as processEntityInputMain,
    processEntityOutput as processEntityOutputMain
} from 'store/serializers/fragments/main';

export const processEntityInput = (values) => ({
    ...values,
    ...processEntityInputMain(values),
    expiresAtTime: 'expiresAtTime' in (values || {}) ? processDateFieldInput(values.expiresAtTime) : null,
    includeNotes: Boolean(values?.includeNotes),
    includeFiles: Boolean(values?.includeFiles)
});

export const processEntityOutput = (values) => ({
    ...values,
    ...processEntityOutputMain(values),
    id: undefined,
    helperFieldStartTime: undefined,
    helperFieldEndTime: undefined,
    expiresAtTime: 'expiresAtTime' in (values || {}) ? processDateFieldOutput(values.expiresAtTime, 'yyyy-MM-dd HH:mm') : undefined,
    expiresAtRecCount: 'expiresAtRecCount' in (values || {}) ? parseInt(values.expiresAtRecCount, 10) : undefined,
    includeNotes: Boolean(values?.includeNotes),
    includeFiles: Boolean(values?.includeFiles)
});
